module.exports = __webpack_public_path__ + "static/media/shop.87141087.svg";